'use client';
import { ReactNode } from 'react';
import { SWRConfig } from 'swr';
import { defaultFetcher } from './fetcher';
import { registerCustomErrors } from './deserializeError';

registerCustomErrors();

export function SWRProvider({ children }: { children: ReactNode }) {
  return (
    <SWRConfig value={{ fetcher: defaultFetcher, shouldRetryOnError: false }}>{children}</SWRConfig>
  );
}
